<template>
  <v-row no-gutters>
    <v-col
      cols="12"
      :class="{ show: show }"
      class="screen-share-dialog"
      :style="{
        'background-color': getWebchat().campaign.color,
        color: invertColor(getWebchat().campaign.color),
      }"
    >
      <v-row no-gutters class="pt-2">
        <v-col cols="12">
          {{ $t("shareScreen") }}
        </v-col>
        <v-col cols="12">
          <v-btn
            text
            @click.native="yes"
            :style="{
              color: invertColor(getWebchat().campaign.color),
            }"
            >{{ $t("yes") }}</v-btn
          >
          <v-btn
            text
            @click.native="no"
            :style="{
              color: invertColor(getWebchat().campaign.color),
            }"
            >{{ $t("no") }}</v-btn
          >
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { invertColor } from "@/assets/utils";
export default {
  props: { show: Boolean },
  name: "screen-share-dialog",
  data() {
    return {
      dialog: false,
      window: window,
    };
  },

  methods: {
    invertColor,

    no() {
      this.$emit("no", false);
    },

    yes() {
      this.$emit("yes", true);
    },

    getWebchat() {
      return this.$store.state[
        this.$store.state.findIndex(
          (e) => e.configuration.campaign === this.$route.query.campaign
        )
      ];
    },
  },
};
</script>

<style>
.screen-share-dialog {
  top: 0px;
  height: 75px;
  opacity: 0;
  padding-top: 10px;
  border-top: 1px solid #00000054;
  box-shadow: 0px 4px 5px -3px #00000066;
  text-align: center;
  transition: all 0.3s ease-out;
}

.screen-share-dialog::after {
  content: "";
  background: linear-gradient(
    129deg,
    rgba(35, 146, 236, 0),
    rgba(0, 0, 0, 0.35)
  );
  background-blend-mode: overlay;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 0;
}

.screen-share-dialog.show {
  top: 75px;
  opacity: 1;
  z-index: 999;
}

.screen-share-dialog button {
  z-index: 2;
  opacity: 0.8;
}
</style>
